import React from "react";
import "./SwordSlashAnim.css";

const SwordSlashAnim = ({ style = {}, onEnd }) => (
  <div className="sword-slash-anim" style={style} onAnimationEnd={onEnd}>
    <div className="slash-effect" />
  </div>
);

export default SwordSlashAnim;